import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { FORGOT_PASSWORD } from "../Constants";
import { ForgotPasswordSuccess, ForgotPasswordFailure } from "../Actions/ForgotPasswordAction";

function* ForgotPasswordRequest(actions) {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank") };
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/forgot_password`,
      {
        email: actions.payload.email,
        bankcode: actions.payload.bankcode,
      },
      { headers: headers }
    );
    if (res.status === 200) {
      yield put(ForgotPasswordSuccess(res.data));
    } else yield put(ForgotPasswordFailure(res));
  } catch (e) {
    yield put(ForgotPasswordFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(FORGOT_PASSWORD, ForgotPasswordRequest);
}

export default function* ForgotPasswordSaga() {
  yield all([actionWatcher()]);
}
